<!--<div [ngSwitch]="mode">-->
<h3>Dev Only!</h3>

<!--
<br />
<br />
-->

<!-- Run some tests with an ng-template. -->
<!--
<ng-template dynamic-component-host
             id="dynamic-component-host"
             name="formFieldDirective"
             #formFieldDirective></ng-template>
-->
<!-- Create multiple templates. -->
<!--
<ng-container *ngFor="let templateRowIndex of this.TemplateRowIndexes; let iRow=index;">
    <ng-container *ngFor="let templateColIndex of this.TemplateColumnIndexes; let iCol=index">
        <ng-template dynamic-component-host
                     name="ng-template{{iRow}}-{{iCol}}">
        </ng-template>

        <span *ngIf="! this.SelectedFlag(iRow,iCol)"
              (click)="this.spanClicked(iRow,iCol)">Template {{iRow}}-{{iCol}}</span>

        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
    </ng-container>

    <br />
    <br />
</ng-container>
-->
<!--
<div>
    <div *ngIf="this.Mode === 'design'">
        <mat-form-field appearance="outline" [floatLabel]="'always'">
            <mat-label *ngIf="this.ShowLabel">{{this.DisplayName}}</mat-label>

            <input matInput
                   placeholder="{{this.PlaceholderText}}"
                   value="{{this.DefaultValue}}"
                   disabled />
        </mat-form-field>
    </div>

    <div *ngIf="(this.Mode === 'preview') || (this.Mode === 'instance')">
        <ng-container *ngIf="(this.ControlType === 'Reactive Forms')">
            <ng-container *ngIf="this.FormControl !== null">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label *ngIf="this.ShowLabel">{{this.DisplayName}}</mat-label>

                    <ng-container *ngIf="! this.ReadOnly">
                        <input matInput
                               type="text"
                               placeholder="{{this.PlaceholderText}}"
                               [formControl]="this.FormControl"
                               (blur)="this.handleOnBlur()" />
                    </ng-container>

                    <ng-container *ngIf="this.ReadOnly">
                        <input matInput
                               type="text"
                               readonly
                               placeholder="{{this.PlaceholderText}}"
                               [formControl]="this.FormControl"
                               (blur)="this.handleOnBlur()" />
                    </ng-container>
                </mat-form-field>
            </ng-container>

        </ng-container>
    </div>

</div>
-->
